import { render, staticRenderFns } from "./ProjectFiles.vue?vue&type=template&id=57824bc4&scoped=true&lang=html"
import script from "./ProjectFiles.vue?vue&type=script&lang=js"
export * from "./ProjectFiles.vue?vue&type=script&lang=js"
import style0 from "./ProjectFiles.vue?vue&type=style&index=0&id=57824bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57824bc4",
  null
  
)

export default component.exports